import React, { useEffect } from 'react';
import LmsMigrationState from './LmsMigrationState';
import LmsMigrationList from './LmsMigrationList';
import TextWinds from '../../../components/common/TextWinds';
import { LmsMigrationStatus } from '../../../constants/types/lms-type';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Buttons from '../../../components/common/Buttons';
import StudentMigrationModal from '../studentmgmt/StudentMigrationModal';
import { openModal } from '../../../store/features/modalSlice';
import { useAppDispatch } from '../../../store/hook';
import MigrationGuideModal from './MigrationGuideModal';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const LmsMigrationPage = () => {
  const [params, setParams] = useSearchParams({
    status: LmsMigrationStatus.SUCCESS,
  });
  const status =
    (params.get('status') as LmsMigrationStatus) || LmsMigrationStatus.SUCCESS;

  const { classId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const setState = (status: LmsMigrationStatus) => {
    params.set('status', status);
    setParams(params);
  };

  // --- 안내 모달 ---
  // TODO: api 연결로 바꿔야함
  const hasIntegrated: boolean = false;

  useEffect(() => {
    let migrationGuideModalShown = localStorage.getItem(
      'migrationGuideModalShown',
    );
    if (migrationGuideModalShown === null) {
      migrationGuideModalShown = 'true';
      localStorage.setItem('migrationGuideModalShown', 'true');
    }

    // 1st. 다시보지않기 체크
    if (migrationGuideModalShown !== 'false') {
      // 2nd. 연동 여부 체크
      if (!hasIntegrated) {
        openGuideModal();
      }
    }
  }, [hasIntegrated]);

  const openGuideModal = () => {
    dispatch(
      openModal({
        body: <MigrationGuideModal />,
      }),
    );
  };

  const openMigrationModal = () => {
    dispatch(
      openModal({
        body: (
          <StudentMigrationModal
            classId={classId}
            onComplete={() => navigate('../migration')}
          />
        ),
      }),
    );
  };

  return (
    <div className="flex w-full flex-col pt-6 xl:px-5">
      <section className="flex flex-row items-center justify-between px-5 xl:px-0">
        <div className="flex items-center gap-2">
          <ArrowLeftIcon
            onClick={() => navigate(`../signup-management`)}
            className="h-6 w-6 cursor-pointer"
          />
          <TextWinds type="title_h2" xlType="title_h3">
            구버전 학생 가져오기
          </TextWinds>
        </div>
        <div>
          <Buttons
            type="filled"
            color="red5"
            isHeight="titlebutton"
            onClick={openMigrationModal}
          >
            구 버전 연동하기
          </Buttons>
        </div>
      </section>
      <div className="my-5 flex flex-col gap-x-1 bg-white p-4 xl:rounded-lg xl:p-4 xl:py-6 xl:shadow-card">
        {/* <LmsMigrationLoading /> */}
        <LmsMigrationState value={status} onChange={setState} />
        <LmsMigrationList status={status} />
      </div>
    </div>
  );
};

export default LmsMigrationPage;
